import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from 'react';
import {
  Box,
  GDSStyleObject,
  FormField,
  TextInput,
} from '@leagueplatform/genesis-core';
import COBQuestioner from '../../../../assets/json/COB_QUESTIONER.json';
import {
  isEmpty,
  isNoSpace,
  isAlphaNumberic,
  medicareValidation,
} from '../../../helpers/helpers';
import './style_medicare-coverage.css';
import useCobStore from '../../../../store/cob-store';
import { COBLayout } from '../../../cob-layout/cob-layout';

const intialValue = {
  claimNumber: '',
};

export const MedicareCoverage = forwardRef((props: any, ref) => {
  const { errorHandling, OPISResponseInfo, nextDisabled } = props;

  const dependantList = useCobStore((state: any) => state.demographics);
  const [claimNumberError, setClaimNumberError] = useState<string>('');
  const [form, setForm] = useState(intialValue);
  const [errors, setErrors] = useState<boolean>(false);

  const formField =
    isEmpty(form.claimNumber) || medicareValidation(form.claimNumber);

  useEffect(() => {
    if (formField) {
      errorHandling(false);
    } else {
      errorHandling(true);
    }
  }, [formField, errorHandling, form]);

  useImperativeHandle(ref, () => ({
    callValidation() {
      if (isEmpty(form.claimNumber)) {
        setClaimNumberError(COBQuestioner.COB.ERRORS.REQUIREDFIELD);
        setErrors(true);
      } else if (medicareValidation(form.claimNumber)) {
        setClaimNumberError(COBQuestioner.COB.ERRORS.CLAIMNUMBER);
        setErrors(true);
      } else {
        setClaimNumberError('');
        setErrors(false);
      }
    },
  }));

  useEffect(() => {
    nextDisabled(false);
  }, [nextDisabled]);

  const updateErrorState = (value: string) => {
    if (isEmpty(value)) {
      setClaimNumberError(COBQuestioner.COB.ERRORS.REQUIREDFIELD);
      setErrors(true);
    } else {
      setClaimNumberError('');
      setErrors(false);
    }
  };
  const onUpdateField = (event: any) => {
    const { value } = event.target;
    setForm({
      claimNumber: isNoSpace(value) ? '' : isAlphaNumberic(value),
    });
    OPISResponseInfo.claimNumber = event.target.value;
    updateErrorState(value);
  };

  const onBlurField = (event: any) => {
    updateErrorState(event.target.value);
  };

  const onKeyPressField = (event: any) => {
    updateErrorState(event.target.value);
  };

  useEffect(() => {
    if (OPISResponseInfo?.claimNumber) {
      setForm({
        claimNumber: OPISResponseInfo?.claimNumber,
      });
    }
  }, [OPISResponseInfo]);

  return (
    <COBLayout
      title={
        OPISResponseInfo?.member?.firstName ===
          dependantList.demographics.firstName &&
        OPISResponseInfo.member.dateOfBirth ===
          dependantList?.demographics?.dateOfBirth
          ? COBQuestioner.COB.INFORMATION.YOURMEDICARE
          : `${`${OPISResponseInfo.member.firstName} ${OPISResponseInfo.member.lastName}${COBQuestioner.COB.INFORMATION.DEPENDENTMEDICARE}`}`
      }
      dataTestId="medicare-coverage"
      questionTitle={
        OPISResponseInfo?.member?.firstName ===
        dependantList.demographics.firstName
          ? COBQuestioner.COB.QUESTIONS.CONTROLS.MEDICARECOVERAGE.TITLE
          : `${`${COBQuestioner.COB.QUESTIONS.CONTROLS.MEDICARECOVERAGE.DEPENDENTTITLE} ${OPISResponseInfo.member.firstName}${COBQuestioner.COB.QUESTIONS.CONTROLS.MEDICARECOVERAGE.CONTINUOUSDEPENDANTTITLE}`}`
      }
      disclaimer={
        COBQuestioner.COB.QUESTIONS.CONTROLS.MEDICARECOVERAGE.DISCLAIMER
      }
      isDependant={false}
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '$one $none $none $none',
          } as GDSStyleObject
        }
      >
        <FormField
          id="claimNumber"
          label={
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                lineHeight: '14px',
              }}
            >
              <div>
                {
                  COBQuestioner.COB.QUESTIONS.CONTROLS.MEDICARECOVERAGE
                    .MEDICARENUMBER
                }
              </div>
              <div>
                {
                  COBQuestioner.COB.QUESTIONS.CONTROLS.MEDICARECOVERAGE
                    .MEDICARENUMBERINFORMATION
                }
              </div>
            </div>
          }
          statusIconLabel="Error"
          inputStatus={errors ? 'error' : undefined}
          statusMessage={errors ? claimNumberError : ''}
          css={
            {
              '& label': {
                marginBottom: '10px',
              },
            } as GDSStyleObject
          }
        >
          <TextInput
            name="claimNumber"
            data-testid="claimNumber"
            maxLength={13}
            minLength={9}
            value={form.claimNumber}
            onChange={onUpdateField}
            onBlur={onBlurField}
            onKeyPress={onKeyPressField}
            placeholder={
              COBQuestioner.COB.QUESTIONS.CONTROLS.MEDICARECOVERAGE.PLACEHOLDER
            }
          />
        </FormField>
      </Box>
    </COBLayout>
  );
});
